<div class="node-palette" id="node-inspector" cdkDropList (cdkDropListDropped)="drop($event)">
   <section class="palette-section" *ngFor="let section of paletteSections; trackBy: trackBySection">
      <header
         class="palette-section__header"
         role="button"
         tabindex="0"
         (click)="toggleSection(section.id)"
         (keydown.enter)="toggleSection(section.id)"
         (keydown.space)="toggleSection(section.id); $event.preventDefault()"
      >
         <div class="palette-section__title">
            <i [class]="section.icon"></i>
            <span>{{ section.titleKey | translate }}</span>
         </div>
         <div class="palette-section__meta">
            <span class="palette-section__count">{{ section.nodes.length }}</span>
            <i class="pi palette-section__toggle" [ngClass]="isSectionCollapsed(section.id) ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
         </div>
      </header>

      <div class="palette-section__body" *ngIf="!isSectionCollapsed(section.id)">
         <div
            class="palette-node"
            *ngFor="let node of section.nodes; trackBy: trackByNode"
            cdkDrag
            [id]="node.id"
            [style.--node-color]="getNodeColor(node.id)"
            [style.--node-text-color]="getNodeTextColor(node.id)"
            [pTooltip]="
               isChannelDisabled(node.id)
                  ? ('DATA.MODULES.CAMPAINGS.WORKFLOWS.CHANNEL_NOT_CONFIGURED' | translate)
                  : null
            "
            tooltipPosition="top"
         >
            <ng-container *ngIf="getNodeShape(node.id) as nodeShape">
               <div *ngIf="nodeShape === 'diamond'; else nonDiamondShape" class="palette-node__shape palette-node__shape--diamond-svg">
                  <svg class="palette-node__diamond-svg" viewBox="0 0 120 60" preserveAspectRatio="none" aria-hidden="true">
                     <polygon points="60,1.5 118.5,30 60,58.5 1.5,30"></polygon>
                  </svg>
                  <span *ngIf="isAiNode(node.id)" class="palette-node__tag">IA</span>
                  <i *ngIf="isChannelDisabled(node.id)" class="pi pi-exclamation-triangle palette-node__warning"></i>
                  <span class="palette-node__label">{{ node.name }}</span>
               </div>

               <ng-template #nonDiamondShape>
                  <div
                     *ngIf="isFlexPolygonNode(node.id); else regularShape"
                     class="palette-node__shape palette-node__shape--poly-svg"
                     [ngClass]="{
                        'palette-node__shape--poly-partial': node.id === 'offerPartialPayment',
                        'palette-node__shape--poly-agreement': node.id === 'offerPaymentAgreement'
                     }"
                  >
                     <svg
                        class="palette-node__poly-svg"
                        [attr.viewBox]="getFlexNodeViewBox(node.id)"
                        preserveAspectRatio="xMidYMid meet"
                        aria-hidden="true"
                     >
                        <polygon [attr.points]="getFlexNodePolygonPoints(node.id)"></polygon>
                     </svg>
                     <span *ngIf="isAiNode(node.id)" class="palette-node__tag">IA</span>
                     <i *ngIf="isChannelDisabled(node.id)" class="pi pi-exclamation-triangle palette-node__warning"></i>
                     <span class="palette-node__label">{{ node.name }}</span>
                  </div>
               </ng-template>

               <ng-template #regularShape>
                  <div class="palette-node__shape" [ngClass]="'palette-node__shape--' + nodeShape">
                     <span *ngIf="isAiNode(node.id)" class="palette-node__tag">IA</span>
                     <i *ngIf="isChannelDisabled(node.id)" class="pi pi-exclamation-triangle palette-node__warning"></i>
                     <ng-container *ngIf="node.id === 'startChatConversation'; else defaultLabel">
                        <svg
                           xmlns="http://www.w3.org/2000/svg"
                           viewBox="0 0 24 24"
                           style="width:20px;height:20px;display:block;margin:auto"
                           aria-hidden="true"
                        >
                           <path fill="#25D366" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
                        </svg>
                     </ng-container>
                     <ng-template #defaultLabel>
                        <span class="palette-node__label">{{ node.name }}</span>
                     </ng-template>
                  </div>
               </ng-template>
            </ng-container>
         </div>
      </div>
   </section>
</div>

<p-dialog header="" [modal]="true" [(visible)]="showWarningModal" [style]="{ width: 'min(28rem, 92vw)' }">
   <div class="flex flex-column gap-3 items-start align-items-center justify-content-center">
      <i class="pi pi-exclamation-triangle text-yellow-600 mt-1" style="font-size: 2rem"></i>
      <div>
         <div class="font-bold text-lg mb-2 font-800">Alerta!</div>

         <p class="m-0 text-sm text-gray-500" *ngIf="warningType === 'channel'">
            {{ 'DATA.MODULES.CAMPAINGS.WORKFLOWS.ALERT_MISSING_CONFIG' | translate: { canal: currentChannel } }}
         </p>

         <p class="m-0 text-sm text-gray-500" *ngIf="warningType === 'waitNode'">
            Sólo puedes añadir un nodo de espera por flujo.
         </p>
      </div>

      <div class="flex justify-content-end gap-2">
         <p-button label="Entendido" severity="secondary" (onClick)="showWarningModal = false; warningType = null" />
      </div>
   </div>
</p-dialog>
